<script>
import appConfig from "@/app.config";

import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title}` : appConfig.title;
    },
  },

  mounted() {
    this.$store.dispatch("auth/getIndustry");
    this.$store.dispatch("auth/getEntity");
    this.$store.dispatch("auth/getRole");
    this.$store.dispatch("utils/fetchIndystryData");

    this.$store.dispatch("utils/fetchRolesCount");
    this.$store.dispatch("utils/fetchDepartmentOptions");
    // this.$store.dispatch("utils/fetchDepartments");
    this.$store.dispatch("utils/getDevices");
    this.$store.dispatch("utils/fetchEmploymentRelationship");
    this.$store.dispatch("utils/fetchPeopleOptionFields", {
      peopleFilter: { department: "" },
    });
    this.$store.dispatch("utils/fetchRoleChoices");
    this.$store.dispatch("people/fetchHomeBanner");
    this.$store.dispatch("auth/currentUser");
    this.$store.dispatch("utils/getSignatures");
    this.$store.dispatch("utils/fetchVersion");
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
  },
};
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
